// extracted by mini-css-extract-plugin
module.exports = {"countrySelect":"Phone2_countrySelect_13e80"};